export enum ClipType {
  Intro = 0,
  Background = 1,
  Middle = 2,
  Outro = 3
}

export enum VideoThemeClipTypeEnum {
  INTRO = 'Intro',
  BACKGROUND = 'Background',
  MIDDLE = 'Middle',
  OUTRO = 'Outro'
}
